import {
  errors,
  MINIMAL_STATIONS_COUNT_FOR_DURATION_CALCULATION,
} from "../constants";
import {
  createErrorResult,
  createErrorResultFromException,
  SimpleResult,
} from "../dto";
import {
  Api,
  getCompanyId,
  getStationTimingPairStatsPath,
  Log,
} from "../helpers";
import {
  IStationTimingPairStatsCriteriaDto,
  IStationTimingPairStatsDto,
} from "../models";

export class StationTimingApi {
  /**
   * Real travel times per adjacent station pair, measured from ride GPS arrivals (RYDE-7994).
   * Read-only: the caller previews the numbers and decides what to apply, nothing is persisted here.
   */
  static async getStationTimingPairStats(
    criteria: IStationTimingPairStatsCriteriaDto,
  ): Promise<SimpleResult<IStationTimingPairStatsDto>> {
    const companyId = getCompanyId();

    if (!companyId) {
      Log.warn(
        "getStationTimingPairStats aborted: companyId is not loaded yet",
      );
      return createErrorResult(errors.common.invalidCompanyId);
    }

    if (
      criteria.stationIds.length <
      MINIMAL_STATIONS_COUNT_FOR_DURATION_CALCULATION
    ) {
      return createErrorResult(errors.stationTiming.notEnoughStations);
    }

    const requestUrl = getStationTimingPairStatsPath(companyId);

    try {
      const response = await Api.post<SimpleResult<IStationTimingPairStatsDto>>(
        requestUrl,
        criteria,
      );

      return (
        response?.data ??
        createErrorResult<IStationTimingPairStatsDto>(
          errors.common.emptyApiResponse,
        )
      );
    } catch (error) {
      return createErrorResultFromException<IStationTimingPairStatsDto>(
        error,
        criteria,
      );
    }
  }
}
